// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3m5C1","Form":"Button_Form__1Geie","Edit":"Button_Edit__1WEM5","Delete":"Button_Delete__3osfI"};